import React from 'react';
import { Typography } from '@mui/material';
import { Column } from 'components/shared/TableListing/types';
import { green, grey, lightGreen } from '@mui/material/colors';
import {
  Money,
  Discount,
  PriceCheck,
  ArrowUpward,
  AttachMoney,
  AccountBalance,
  CheckCircleOutlined,
} from '@mui/icons-material';

import { QuoteChargeListingEntity, QuoteChargeListingContext } from '../../../types';
import {
  DescriptionCell,
  ChargeValueCell,
  ReadOnlyValueCell,
  ChargeValueWithTypeCell,
  EquipmentChargeRowTotalCell,
  EquipmentChargeGrandTotalCell,
  EquipmentChargeColumnTotalCell,
} from './cells';

export const invoiceDetailsListingColumns: Column<QuoteChargeListingEntity, QuoteChargeListingContext>[] = [
  {
    header: 'Description',
    renderKey: 'type',
    renderCell: ({ rowIndex, context: { onRemoveRow, onLinkCharge, onUnLinkCharge, ...otherActions } }) => (
      <DescriptionCell
        rowIndex={rowIndex}
        onRemoveRow={() => onRemoveRow(rowIndex)}
        onLinkCharge={(attachId, linkIndex) => onLinkCharge(attachId, rowIndex, linkIndex)}
        onUnLinkCharge={() => onUnLinkCharge(rowIndex)}
        {...otherActions}
      />
    ),
    renderFooter: () => <Typography>Total</Typography>,
    headerStyles: {
      minHeight: 'auto',
      backgroundColor: grey[200],
    },
    width: '18rem',
    cellStyles: {
      minWidth: '10rem',
      alignItems: 'flex-start',
    },
    footerStyles: {
      minHeight: 'auto',
      color: green[800],
      backgroundColor: lightGreen['50'],
    },
  },
  {
    renderKey: 'wholesalePrice',
    header: 'Wholesale Price',
    startIcon: <PriceCheck fontSize="small" />,
    renderCell: ({ rowIndex }) => <ChargeValueCell rowIndex={rowIndex} type="wholesalePrice" />,
    renderFooter: () => <EquipmentChargeColumnTotalCell field="wholesalePrice" />,
    headerStyles: {
      minHeight: 'auto',
      backgroundColor: grey[200],
    },
    cellStyles: {
      minWidth: '10rem',
      alignItems: 'flex-start',
    },
    footerStyles: {
      minHeight: 'auto',
      color: green[800],
      backgroundColor: lightGreen['50'],
    },
  },
  {
    header: 'Markup',
    renderKey: 'markup',
    startIcon: <ArrowUpward fontSize="small" />,
    renderCell: ({ rowIndex }) => <ChargeValueWithTypeCell rowIndex={rowIndex} type="markup" />,
    renderFooter: () => <EquipmentChargeColumnTotalCell field="markup" />,
    headerStyles: {
      minHeight: 'auto',
      backgroundColor: grey[200],
    },
    cellStyles: {
      minWidth: '10rem',
      alignItems: 'flex-start',
    },
    footerStyles: {
      minHeight: 'auto',
      color: green[800],
      backgroundColor: lightGreen['50'],
    },
  },
  {
    header: 'Retail Price',
    renderKey: 'retailPrice',
    startIcon: <AttachMoney fontSize="small" />,
    renderCell: ({ rowIndex }) => <ReadOnlyValueCell rowIndex={rowIndex} type="retailPrice" />,
    renderFooter: () => <EquipmentChargeColumnTotalCell field="retailPrice" />,
    headerStyles: {
      minHeight: 'auto',
      backgroundColor: grey[200],
    },
    cellStyles: {
      minWidth: '10rem',
      alignItems: 'flex-start',
    },
    footerStyles: {
      minHeight: 'auto',
      color: green[800],
      backgroundColor: lightGreen['50'],
    },
  },
  {
    header: 'Discount',
    renderKey: 'discount',
    startIcon: <Discount fontSize="small" />,
    renderCell: ({ rowIndex }) => <ChargeValueWithTypeCell rowIndex={rowIndex} type="discount" />,
    renderFooter: () => <EquipmentChargeColumnTotalCell field="discount" />,
    headerStyles: {
      minHeight: 'auto',
      backgroundColor: grey[200],
    },
    cellStyles: {
      minWidth: '10rem',
      alignItems: 'flex-start',
    },
    footerStyles: {
      minHeight: 'auto',
      color: green[800],
      backgroundColor: lightGreen['50'],
    },
  },
  {
    header: 'Net Price',
    renderKey: 'netPrice',
    startIcon: <Money fontSize="small" />,
    renderCell: ({ rowIndex }) => <ReadOnlyValueCell rowIndex={rowIndex} type="netPrice" />,
    renderFooter: () => <EquipmentChargeColumnTotalCell field="netPrice" />,
    headerStyles: {
      minHeight: 'auto',
      backgroundColor: grey[200],
    },
    cellStyles: {
      minWidth: '10rem',
      alignItems: 'flex-start',
    },
    footerStyles: {
      minHeight: 'auto',
      color: green[800],
      backgroundColor: lightGreen['50'],
    },
  },
  {
    header: 'Sales Tax',
    renderKey: 'salesTax',
    startIcon: <AccountBalance fontSize="small" />,
    renderCell: ({ rowIndex }) => <ChargeValueWithTypeCell rowIndex={rowIndex} type="salesTax" />,
    renderFooter: () => <EquipmentChargeColumnTotalCell field="salesTax" />,
    headerStyles: {
      minHeight: 'auto',
      backgroundColor: grey[200],
    },
    cellStyles: {
      minWidth: '10rem',
      alignItems: 'flex-start',
    },
    footerStyles: {
      minHeight: 'auto',
      color: green[800],
      backgroundColor: lightGreen['50'],
    },
  },
  {
    header: 'Total',
    renderKey: 'total',
    startIcon: <CheckCircleOutlined fontSize="small" />,
    renderCell: ({ rowIndex }) => <EquipmentChargeRowTotalCell rowIndex={rowIndex} />,
    renderFooter: () => <EquipmentChargeGrandTotalCell />,
    width: '8rem',
    headerStyles: {
      minHeight: 'auto',
      backgroundColor: grey[200],
    },
    cellStyles: {
      alignItems: 'flex-start',
    },
    footerStyles: {
      minHeight: 'auto',
      color: green[800],
      backgroundColor: lightGreen['50'],
    },
  },
];
